<template>
  <div>
    <div class="tax-information hour-salary">
      <div class="tax-head">
        <h1>Salary Calculation</h1>
        <div>
          <p>
            {{salaryType}} from <b>{{salaryFrom}}</b> to <b>{{salaryTo}}</b>
          </p>
        </div>
      </div>

<!--      <div class="navbar-holder">
        <ul class="inner-navbar">
          <li class="li-width">
            <div class="form-group">
              <label>Salary Period</label>
              <div class="">
                <date-picker
                  v-model="range"
                  lang="en"
                  format="YYYY-MM-DD"
                  range
                  type="date"
                  width="400"
                  @change="onChange($event)"
                >
                <template v-slot:footer="{ emit }">
                  <span style="text-align: left;float: left;">
                    <button class="btn mx-btn mx-btn-text" @click="getDateByMonth(emit,'lastMonth')">Last Month</button>
                    <button class="btn mx-btn mx-btn-text" @click="getDateByMonth(emit,'currentMonth')">Current Month</button>
                    <button class="btn mx-btn mx-btn-text" @click="getDateByMonth(emit,'nextMonth')">Next Month</button>
                    <button class="btn mx-btn mx-btn-text" @click="getDateByMonth(emit,'twoMonths')">Next Two Month</button>
                  </span>
                </template>
                </date-picker>
              </div>
            </div>
                <span v-if="invalidCalc === 'invalid'" :class="{textRed : invalidCalc === 'invalid'}">Date is required</span>
          </li>
          <li v-if="lock1 != 1">
            <a class="btn btn-primary"
              data-toggle="modal"
              data-target="#attendanceConfirm-modal"
              >Calculate</a
            >
          </li>
        </ul>
      </div>-->
      <div class="table-scroll salary-calculation">
        <table class="table" id="tblData" style="position: relative">
           <span class="spinnerCustom">
                     <clip-loader :loading="loadingSpinMain" :size="sizeMain" :color="spinnerColor"></clip-loader>
                </span>
          <thead class="table-head">
            <tr>
              <th scope="col"></th>
              <th scope="col">Employee</th>
              <th scope="col">Monthly Salary</th>
              <th scope="col">Allowances/Bonuses</th>
              <th scope="col">Deductions</th>
              <th scope="col">Tax</th>
              <th scope="col">NET PAYABLE</th>
              <!-- <th class="p-0" scope="col"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="salary in salaryCalculations" :key="salary.user.id">
              <td>
                <a
                  href="javascript:void(0)"
                  data-toggle="modal"
                  data-target="#deduction-modal"
                  ><i class="ico ico-edit" v-on:click="showModalBenefits(salary.user)"></i
                ></a>
              </td>
              <td class="text-capitalize" @click="setUserData(salary.user)">
                <router-link :to="{ path: '/employee/salary/' + salary.user.uuid + '' }">
                  {{ salary.user.name }}
                </router-link>
              </td>
              <td>{{ currencyFormatter2((empCurrentSalary[salary.user.id])?empCurrentSalary[salary.user.id]:0) }}</td>
              <td>{{ currencyFormatter2((empAllow[salary.user.id])?empAllow[salary.user.id]:0) }}</td>
              <td>
<!--                <pre class="language-json"><code>{{ salary}}</code></pre>-->
                {{ currencyFormatter2((empDect[salary.user.id])?empDect[salary.user.id]:0) }}
              </td>
              <td> {{ currencyFormatter2((empTax[salary.user.id] != null)?empTax[salary.user.id]:0) }}</td>
              <td>{{ currencyFormatter2((empNetPay[salary.user.id])?empNetPay[salary.user.id]:0) }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>{{currencyFormatter2(totalBasicSalary)}}</td>
              <td>{{currencyFormatter2(totalAllowance)}}</td>
              <td>{{currencyFormatter2(totalDeduction)}}</td>
              <td>{{currencyFormatter2(totalTax)}}</td>
              <!-- <td v-if="sumAllAmount != ''" class="total-td">Total</td> -->
              <td >Total &nbsp;&nbsp;=&nbsp;&nbsp;&nbsp; <strong>{{ currencyFormatter2(sumAllAmount) }}</strong></td>
              <!-- <td class="p-0"></td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="navbar-holder text-right" v-if="lockShowHide">
        <a v-on:click="recalculateSalary()" class="btn btn-warning"><clip-loader :loading="updateLoading" :size="size" :color="spinnerColor"></clip-loader>Recalculate Salary</a>
        <a v-on:click="UpdateCalculation()" class="btn btn-warning"><clip-loader :loading="updateLoading" :size="size" :color="spinnerColor"></clip-loader>Update</a>
            <a v-on:click="lockSalarySendNotfi()" class="btn btn-warning"
              ><clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
              Lock & Send Email</a>

      </div>

      <!-- attendance confirm modal -->

      <div
        class="modal fade add-absence-model"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="attendanceConfirm-modal"
      >
        <div class="modal-dialog modal-xs">
          <div class="modal-content bg-white salary-cal-model">
            <div class="modal-header">
              <div class="modal-title">
                <h3 class=" mb-0 text-primary">Calculate Salary</h3 >

              </div>
               <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="ico-cross"></span>
                </button>
            </div>
            <div class="content-wrapper pt-10 pb-20">


              <div class="modal-body">
                <div class="inputs-wrapper">
                  <div class="inputs-holder">
                    <div class="sticky-radio">
                    <label class="custom-radio">
                      <input type="radio" v-model="calculationType" value="with" name="with"   @change="attendanceWithWithout" />
                      <span class="radio-check font-weight-light"> Calculate salary with attendance. </span>
                    </label>
                  </div>
                  <div class="sticky-radio">
                    <label class="custom-radio">
                      <input type="radio" v-model="calculationType" value="without" name="with" @change="attendanceWithWithout" />
                      <span class="radio-check"> Calculate salary without attendance. </span>
                    </label>
                  </div>
                </div>
                </div>

              </div>

              <div class="bottom-btn">
                <!-- data-dismiss="modal" -->
                <!-- @click.prevent="salaryCalculator" -->
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  data-dismiss="modal"
                  @click.prevent="salaryCalculator"
                >
                  Calculate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Bonus and deduction modal -->
      <div
        class="modal fade bd-example-modal-lg slab-info-model"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="deduction-modal"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content bg-white salary-cal-model">
            <div class="content-wrapper">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="clearData"
              >
                <span class="ico-cross"></span>
              </button>
              <header class="model-heading">
                <h1 class="text-capitalize" >{{ singleEmployee.name }}</h1>

                <div class="bonus-deduct">
                  Bonus/Deduction Details From {{ form.from_date }} to
                  {{ form.to_date }}
                </div>
                <p >
                </p>
              </header>

              <div class="table-scroll">
                <table class="table">
                  <thead class="table-head">
                    <tr>
                      <th scope="col">Type</th>
                      <th scope="col">Description</th>
                      <th scope="col">Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="alwnce of employeeBenefitArray" :key="alwnce.id">
                      <td>
                        <div class="nav-selectdrop">
                          <select
                            id="inputState"
                            class="form-control"
                            :class="'rowClass' + alwnce.id"
                          >
                            <option :selected="alwnce.hasOwnProperty('type') && alwnce.type === 'Deduction'">Deduction</option>
                            <option :selected="alwnce.hasOwnProperty('type') && alwnce.type === 'Bonus' || !alwnce.hasOwnProperty('type')">
                              Bonus
                            </option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          placeholder=""
                          :value="alwnce.companyBenefit.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          placeholder=""
                          :value="alwnce.benefits_amount"
                        />
                      </td>
                      <td>
                        <div class="d-flex">
                          <a
                            href="javascript:void(0)"
                            class="ml-n15"
                            @click="addTableRow"
                            ><span class="ico-plus"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="ml-10"
                            @click="delTableRow(alwnce.id)"
                            ><i class="ico-delete"></i
                          ></a>
                        </div>
                      </td>
                    </tr>

                    <tr v-for="(item, index) of bonusDeductionLoop" :key="index" :id="'newAddRow2'+index">
                      <td>
                        <div class="nav-selectdrop">
                          <select class="form-control" :class="'rowClassSelected'" >
                            <option :selected="item.type === 'Deduction'" value="deduction" >
                              Deduction
                            </option>
                            <option :selected="item.type === 'Bonus'" value="bonus">
                              Bonus
                            </option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          :value="item.companyBenefit.name"
                          :class="'rowClassDisc'"
                          placeholder=""
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          :value="item.benefits_amount"
                          :class="'rowClassAmount'"
                          placeholder=""
                        />
                      </td>

                      <td>
                        <div class="d-flex">
                          <a
                            href="javascript:void(0)"
                            class="ml-n15"
                            @click="addTableRow"
                            ><span class="ico-plus"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="ml-10"
                            @click="delTableRow3(index,'newAddRow2'+index)"
                            ><i class="ico-delete"></i
                          ></a>
                        </div>
                      </td>
                    </tr>

                    <!-- new added rows -->
                    <!-- do not change this html because from this getting values by parent to children node method used getBonusDeductionDetail() -->
                    <tr v-for="(tr, index) of tableRows" :key="index" :id="'newAddRow'+tr">
                      <td>
                        <div class="nav-selectdrop">
                          <select
                            class="form-control"
                            :class="'rowClassSelectedd'"
                          >
                            <option selected="" value="deduction">
                              Deduction
                            </option>
                            <option value="bonus">Bonus</option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          :class="'rowClassDisc'"
                          placeholder=""
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          :class="'rowClassAmountd'"
                          placeholder=""
                        />
                      </td>

                      <td>
                        <div class="d-flex">
                          <a
                            href="javascript:void(0)"
                            class="ml-n15"
                            @click="addTableRow"
                            ><span class="ico-plus"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="ml-10"
                            @click="delTableRow2(tr,'newAddRow'+tr)"
                            ><i class="ico-delete"></i
                          ></a>
                        </div>
                      </td>
                    </tr>
                    <!-- end do not change this html because from this getting values by parent to children node method used getBonusDeductionDetail() -->
                  </tbody>
                </table>
              </div>

              <div class="bottom-btn">
                <!-- data-dismiss="modal" -->
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  data-dismiss="modal"
                  :data-employeeId="singleEmployee.id"
                  @click="getBonusDeductionDetail(singleEmployee.id)"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import collect from 'collect.js';

export default {
  name: "salary-calculator",

  components: {
    DatePicker,ClipLoader
  },

  data() {
    return {
      sizeMain: '35px',
      loadingSpinMain: false,
      size: '25px',
      spinnerColor: '#00779C',
      loading: false,
      updateLoading: false,
      loadingSaveBtn: false,
      calculationType:"with",
      lockOrUpdateCheck: true,
      totalBasicSalary:0,
      totalAllowance:0,
      totalDeduction:0,
      totalTax:0,
      val: 0,
      date: "",
      company_id: this.$store.getters.getSelectedCompany.id,
      salaryCalculationPeriodId: this.$route.params.id,
      range: "",
      salaryCalculations: [],
      employees: [],
      employeeAllowncesArray: [],
      sumAllAmount: 0,
      empCurrentSalary: [],
      empAllow: [],
      empDect: [],
      empTax: [],
      empNetPay: [],
      popid: 0,
      pop_name: "",
      deduction: 0,
      index: 0,
      taxAmount: [],
      netAmount: 0,
      company_benefit: [],
      rows: [],
      arrayofAllownces: [
        {
          type: "",
          description: "",
          amount: "",
        },
      ],
      defaultAllownce: [
        {
          type: "",
          description: "",
          amount: "",
        },
      ],
      form: {
        company_id: this.$store.getters.getSelectedCompany.id,
        basic_salary: 0,
        from_date: null,
        to_date: null,
        employee_id: [],
        allownces: 0,
        deductions: 0,
        tax: 0,
        netAmount: 0,
        sumAllAmount: 0,
        employee_allow: [],
      },
      lock: {
        from_date: null,
        to_date: null,
        employee_id: [],
      },
      lock1: null,
      bonus: 0,
      bonuses: 0,
      tax: 0,
      salaries: [],
      user: [],
      dataArray: [],
      bonusArray: [],
      is_data: false,
      indexEmp: 0,
      delflag: false,
      empID: 0,
      is_calculate: 0,
      tableRowsCount: 2,
      tableRows: [1],
      singleEmployee: [],
      employeeBenefitArray: [],
      filteredEmpoyee: [],
      employees2: [],
      alwnceAmount: 0,
      deductAmount: 0,
      moreBenefits: [],
      moreDeduction: [],
      bonusAndDeductionArray: [],
      bonusDeductionLoop: [],
      netTaxAmount: 0,
      sumOfBonusDeduction: [],
      seperateAllowances: [],
      allMoreBenefitsDeductions: [],
      lockShowHide:false,
      invalidCalc:'',
      salaryFrom:'',
      salaryTo:'',
      salaryType:'',
    };
  },
  serverPrefetch() {},
  mounted() {},
  created(){
    this.GetSalaryCalculation();
     //this.calculateTaxFromSlabs(139000);

  },
  watch: {
    netTaxAmount(newVal, oldVal) {
    },
  },
  methods: {
    salaryCalculator() {
      if(this.range !== "" && this.range[0] !== null){
        this.sumAllAmount = 0;
        this.tableRows = [1];
        $(".rowClassAmount").val("");
        $(".rowClassAmountd").val("");
        this.allMoreBenefitsDeductions = [];
        this.bonusAndDeductionArray = [];
        this.singleEmployee = [];
        this.bonusDeductionLoop = [];
        this.getTotalCalculationFunction();
        this.invalidCalc = ''
        $("#attendanceConfirm-modal").modal("hide");
      }else{
        this.invalidCalc = 'invalid';
      }
    },
    recalculateSalary(){
      this.sumAllAmount = 0;
      this.tableRows = [1];
      $(".rowClassAmount").val("");
      $(".rowClassAmountd").val("");
      this.allMoreBenefitsDeductions = [];
      this.bonusAndDeductionArray = [];
      this.singleEmployee = [];
      this.bonusDeductionLoop = [];
       this.getTotalCalculationFunction();
    },

    setEmployeeAmount(element,tax_per_month,allowances,deduct,benifits){
      if (element.id) {
        this.empAllow[element.id] = allowances;
        this.empDect[element.id]  = deduct || 0;
        element.sumofAllownce     = allowances;
        element.EmployeeBenefits  = benifits;
        if(element.tax_amount>0){
          this.empTax[element.id]   =element.tax_amount;
        }else{
          this.empTax[element.id]   = tax_per_month;
        }
        this.sumOfBonusDeduction[element.id] = element.basic_salary + element.sumofAllownce - this.empDect[element.id];
      }
      this.empNetPay[element.id] = parseFloat(element.basic_salary) + parseInt(element.sumofAllownce) - this.empDect[element.id] - parseFloat(this.empTax[element.id]);
      },

    getTotalCalculationFunction() {
      this.loadingSpinMain= true;
      this.totalBasicSalary = 0;
      this.totalAllowance = 0;
      this.totalDeduction = 0;
      this.totalTax = 0;

      let params = {
        company_id: this.company_id,
        from_date: this.salaryFrom,
        to_date: this.salaryTo,
        attendanceConfirm: this.calculationType
      };

      this.$axios
        .get(this.$CompanyEmployeesList, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.loadingSpinMain= false;
          //console.log(response.data.result,'response.data.result');
          if (this.singleEmployee.length === 0) {
            this.employees2 = response.data.result;
            this.employees  = this.employees2;

          } else {
            this.employees = this.employees;
            $("#deduction-modal").modal("hide");
            $("#attendanceConfirm-modal").modal("hide");
          }
          this.employees.forEach((element,index) => {
            // this.empAllow[element.id]   = element.sumofAllownce;
            this.empCurrentSalary[element.id]   = element.basic_salary;
            this.sumCurrentEmpSalary += (element.basic_salary>0)?parseInt(element.basic_salary):0;
            this.totalCurrentEmpSalary= this.sumCurrentEmpSalary;
            this.empTax[element.id]     = element.withoutTaxSalary;
            let amountSumOfSBD=(parseInt(element.basic_salary) + element.sumofAllownce) - (parseInt(this.empDect[element.id]));
            let taxPerMonth=  this.calculateTaxFromSlabs(amountSumOfSBD);
            this.empTax[element.id]=taxPerMonth;
             this.setEmployeeAmount(element,parseFloat(taxPerMonth),parseInt(element.sumofAllownce),parseInt(this.empDect[element.id]),parseInt(element.sumofAllownce));
            if(this.calculationType=='without'){
              this.totalBasicSalary += element.basicSalary;
            }else{
              if(element.basicSalary>0){
                this.totalBasicSalary += element.basicSalary;
              }
            }
            this.totalAllowance += element.sumofAllownce;
            // this.totalAllowance += 0;
            this.totalDeduction += this.empDect[element.id];
            this.totalTax += this.empTax[element.id];

            if (isNaN(parseFloat(this.empNetPay[element.id]))) {
              var sumAmount = 0;
            }else{
              var sumAmount = parseFloat(this.empNetPay[element.id]);
            }
            this.sumAllAmount += sumAmount;
            /*var dataSub=
              {
                'tax':this.empTax[element.id],
                'allownces': element.sumofAllownce,
                'deductions':this.empDect[element.id],
              }*/

            //this.employees[element.id]=element.id;
           // console.log(dataSub,'this.employees'); return;
           this.employees[index]['tax']=this.totalTax;
           this.employees[index]['basic_salary']=element.basicSalary;
            this.employees[index]['allownces']=this.totalAllowance;
            this.employees[index]['deductions']=this.totalDeduction;
           // console.log(this.employees[index],'index',index); return;

          });
          //console.log(this.employees,'this.employees');
          // this.totalSalaries();
          this.lockShowHide = true;

        })
        .catch((error) => {
          console.log(error);
        });
    },
    calculateTaxFromSlabs(amount){
      // console.log(amount.toFixed(2),'taxPerMonth.toFixed(2)');
      let taxSlabInfo=  JSON.parse(localStorage.getItem('companyTaxSlab'))
      let taxSlabs = taxSlabInfo.slabs;
      let remainingSalary = amount;

      if (taxSlabInfo.relaxation > 0) {
        let relaxation = (taxSlabInfo.relaxation / 100) * amount;
        remainingSalary = amount - relaxation;
      }

      let amountYearly = remainingSalary * 12;
      let slabAmount = null;

      for (let i = 0; i < taxSlabs.length; i++) {
        let slab = taxSlabs[i];
        if (amountYearly >= slab.amount_from && amountYearly < slab.amount_to) {
          slabAmount = slab;
          break;
        }
      }
      //console.log(slabAmount,'slabAmount',remainingSalary,amountYearly);
      if (!slabAmount) {
        return 0; // No applicable tax slab found
      }

      let amountDifference = amountYearly - slabAmount.amount_from;
      if (slabAmount.is_exceeding_amount == 1 && remainingSalary > slabAmount.exceeding_amount) {
        amountDifference = remainingSalary - slabAmount.exceeding_amount;
      }
      let tax = slabAmount.exceeding;
      let fixedValuePerMonth = slabAmount.fixed_value / 12;
      let amountExceedingYearly = amountDifference * (tax / 100);
      let amountExceedingMonthly = amountExceedingYearly / 12;
      let taxPerMonth = fixedValuePerMonth + amountExceedingMonthly;
      return taxPerMonth.toFixed(2);
      ///return taxPerMonth;
    },

    setUserData(user){
      this.$store.commit('setEmployeeProfileId', user);
    },
    getDateByMonth(emit,type){
      const start = new Date();
      const end = new Date();
      if(type === 'lastMonth'){
        const date = [
          new Date(start.getFullYear(), start.getMonth() - 1, 1),
          new Date(end.getFullYear(), end.getMonth(), 0)
        ];
        emit(date);
      }else if(type === 'currentMonth'){
        const date = [
          new Date(start.getFullYear(), start.getMonth(), 1),
          new Date(end.getFullYear(), end.getMonth() + 1, 0)
        ];
        emit(date);
      }else if(type === 'nextMonth'){
        const date = [
          new Date(start.getFullYear(), start.getMonth() + 1, 1),
          new Date(end.getFullYear(), end.getMonth() + 2, 0)
        ];
        emit(date);
      }else if(type === 'twoMonths'){
        const date = [
          new Date(start.getFullYear(), start.getMonth(), 1),
          new Date(end.getFullYear(), end.getMonth() + 2, 0)
        ];
        emit(date);
      }
    },
    attendanceWithWithout(){

    },
    showModalBenefits(employee) {

      this.alwnceAmount = 0;
      this.deductAmount = 0;
      this.tableRows    = [];

      $(".rowClassAmount").val("");
      $(".rowClassAmountd").val("");
      this.singleEmployee       = employee;

       this.employeeBenefitArray = employee.EmployeeBenefits;
   //   this.employeeBenefitArray = [];
      if (this.bonusAndDeductionArray.length !== 0) {
        this.bonusDeductionLoop = [];
        this.bonusDeductionLoop = this.bonusAndDeductionArray[employee.id];
      }
      if (this.employeeBenefitArray.length === 0) {
        this.tableRows = [1];
      } else {
        this.tableRows = [];
      }
      // if (this.bonusDeductionLoop.length !== 0) {
      //   this.tableRows = [];
      // }

    },
    delTableRow3(index,rowId) {
      $('#'+rowId).remove();
    },
    getBonusDeductionDetail(empl_id) {
      this.alwnceAmount = 0;
      this.deductAmount = 0;
      this.moreDeduction = [];
      this.moreBenefits = [];
      this.tableRows = [];

      // second time calculation of bonus and deduction
      $(".rowClassAmount").each((index, element) => {
        if ($('.rowClassAmount').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "deduction") {
          // if(element.value !== ''){
          var ddamnt = 0;
          if(element.value !== ''){
            ddamnt = parseInt(element.value)
          }else{
            this.deductAmount += 0;
          }
          this.deductAmount += ddamnt;
          this.totalDeduction += this.deductAmount;
          this.moreDeduction.push({
            benefits_amount: ddamnt,
            companyBenefit: { name: $(".rowClassDisc").eq(index).val() },
            type: "d",
            employee_id: empl_id,
          });
          // }
        } else if ($('.rowClassAmount').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "bonus") {
          // if(element.value !== ''){

          var allAmnt = 0;
          if(element.value !== ''){
            allAmnt = parseInt(element.value)
          }else{
            this.alwnceAmount += 0;
          }
          this.alwnceAmount += allAmnt;
          this.totalAllowance += this.alwnceAmount;
          this.moreBenefits.push({
            benefits_amount: allAmnt,
            companyBenefit: { name: $(".rowClassDisc").eq(index).val() },
            type: "b",
            employee_id: empl_id,
          });
          // }
        }
      });

      // first time calculation of bonus and deduction
      $(".rowClassAmountd").each((index, element) => {
        if ($('.rowClassAmountd').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "deduction") {
          // if(element.value !== ''){
          var ddamnt = 0;
          if(element.value !== ''){
            ddamnt = parseInt(element.value)
          }else{
            this.deductAmount += 0;
          }
          this.deductAmount += ddamnt;
          this.totalDeduction += this.deductAmount;
          this.moreDeduction.push({
            benefits_amount: parseInt(element.value),
            companyBenefit: { name: $(".rowClassDisc").eq(index).val() },
            type: "d",
            employee_id: empl_id,
          });
          // }

        } else if ($('.rowClassAmountd').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "bonus") {
          // if(element.value !== ''){
          var allAmnt = 0;
          if(element.value !== ''){
            allAmnt = parseInt(element.value)
          }else{
            this.alwnceAmount += 0;
          }
          this.alwnceAmount += allAmnt;
          this.totalAllowance += this.alwnceAmount;
          this.moreBenefits.push({
            benefits_amount: parseInt(element.value),
            companyBenefit: { name: $(".rowClassDisc").eq(index).val() },
            type: "b",
            employee_id: empl_id,
          });
          // }
        }
      });

      var allowances = 0;
      this.employeeBenefitArray.map((item) => {
        allowances += item.benefits_amount;
        item['type'] = 'b';
      });

      this.salaryCalculations.forEach((element) => {
        var userId= element.user.id
        if (userId === empl_id) {

          this.seperateAllowances[userId]   = this.alwnceAmount;
          this.empAllow[userId]             = this.alwnceAmount + allowances;
          this.empDect[userId]              = this.deductAmount || 0;
          element.sumofAllownce                 = this.alwnceAmount + allowances;
          element.EmployeeBenefits              = this.employeeBenefitArray;
          this.sumOfBonusDeduction[userId]  = (parseFloat(element.basic_salary) + element.sumofAllownce) - this.empDect[userId];

        }
      });

      this.getTaxAmount(this.sumOfBonusDeduction[empl_id],this.employeeBenefitArray,this.alwnceAmount + allowances,this.deductAmount,empl_id);
      if(this.allMoreBenefitsDeductions.hasOwnProperty(empl_id)){
        this.allMoreBenefitsDeductions[empl_id] = [];
      }
      this.allMoreBenefitsDeductions[empl_id] = this.moreBenefits.concat(this.moreDeduction, this.employeeBenefitArray);
      this.bonusAndDeductionArray[empl_id] = this.moreBenefits.concat(this.moreDeduction);

      $("#deduction-modal").modal("hide");
    },
    getBonusDeductionDetail_OLD(empl_id) {
      this.alwnceAmount   = 0;
      this.deductAmount   = 0;
      this.moreDeduction  = [];
      this.moreBenefits   = [];
      this.tableRows      = [];

      // second time calculation of bonus and deduction
      $(".rowClassAmount").each((index, element) => {
        if ($('.rowClassAmount').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "deduction") {
          // if(element.value !== ''){
            var ddamnt = 0;
            if(element.value !== ''){
              ddamnt = parseInt(element.value)
              }else{
                this.deductAmount += 0;
            }
            this.deductAmount += ddamnt;
            this.moreDeduction.push({
              benefits_amount: ddamnt,
              companyBenefit: { name: $(".rowClassDisc").eq(index).val(),amount:ddamnt },
              type: "Deduction",
              employee_id: empl_id,
            });
          // }
        } else if ($('.rowClassAmount').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "bonus") {
          // if(element.value !== ''){
            var allAmnt = 0;
            if(element.value !== ''){
              allAmnt = parseInt(element.value)
              }else{
                this.alwnceAmount += 0;
            }
             this.alwnceAmount += allAmnt;
             this.moreBenefits.push({
              benefits_amount: allAmnt,
              companyBenefit: { name: $(".rowClassDisc").eq(index).val(),amount:allAmnt },
              type: "Bonus",
              employee_id: empl_id,
            });
          // }
        }
      });

      // first time calculation of bouns and deductino
      $(".rowClassAmountd").each((index, element) => {
        if ($('.rowClassAmountd').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "deduction") {
          // if(element.value !== ''){
            var ddamnt = 0;
            if(element.value !== ''){
              ddamnt = parseInt(element.value)
            }else{
                this.deductAmount += 0;
            }
            this.deductAmount += ddamnt;

            this.moreDeduction.push({
              benefits_amount: parseInt(element.value),
              companyBenefit: { name: $(".rowClassDisc").eq(index).val(),amount:parseInt(element.value) },
              type: "Deduction",
              employee_id: empl_id,
            });
          // }

        } else if ($('.rowClassAmountd').eq(index).parent().parent().children(":first-child").children().children().find(":selected").val() === "bonus") {
          // if(element.value !== ''){
            var allAmnt = 0;
            if(element.value !== ''){
              allAmnt = parseInt(element.value)
            }else{
              this.alwnceAmount += 0;
            }
            this.alwnceAmount += allAmnt;
            this.moreBenefits.push({
              benefits_amount: parseInt(element.value),
              companyBenefit: { name: $(".rowClassDisc").eq(index).val(),amount:parseInt(element.value) },
              type: "Bonus",
              employee_id: empl_id,
            });
          // }
        }
      });

      var allowances  = 0;
      var ddAmnt      = 0;
      this.employeeBenefitArray.map((item) => {
        if(item.hasOwnProperty('type') && item.type === 'Bonus' || !item.hasOwnProperty('type')){
          allowances += item.benefits_amount;
          item['type'] = 'Bonus';
        }else if(item.hasOwnProperty('type') && item.type === 'Deduction'){
          ddAmnt += item.benefits_amount;
          item['type'] = 'Deduction';
        }
      });
      this.salaryCalculations.forEach((element) => {
        if (element.user.id === empl_id) {
          this.seperateAllowances[element.user.id]    = this.alwnceAmount;
          this.empAllow[element.user.id]              = this.alwnceAmount + allowances;
          this.empDect[element.user.id]               = this.deductAmount + ddAmnt;
          element.sumofAllownce                       = this.alwnceAmount + allowances;
          element.EmployeeBenefits                    = this.employeeBenefitArray;
          this.sumOfBonusDeduction[element.user.id]   = (element.basic_salary + element.sumofAllownce) - this.empDect[element.user.id];

        }
      });

      this.getTaxAmount(this.sumOfBonusDeduction[empl_id],this.employeeBenefitArray,this.empAllow[empl_id],this.empDect[empl_id],empl_id);
      if(this.allMoreBenefitsDeductions.hasOwnProperty(empl_id)){
        this.allMoreBenefitsDeductions[empl_id] = [];
      }
      this.allMoreBenefitsDeductions[empl_id] = this.moreBenefits.concat(this.moreDeduction, this.employeeBenefitArray);
      this.bonusAndDeductionArray[empl_id]    = this.moreBenefits.concat(this.moreDeduction);
      $("#deduction-modal").modal("hide");
    },

    async getTaxAmount(amount, benifits, allowances, deduct, idd) {
      this.sumAllAmount = 0;
      await this.$axios({
        method: "get",
        params: {
          company_id: this.company_id,
          amount: amount,
        },
        url: this.$GetTaxByAmount,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          // this.empTax[idd] = res.data.result.tax_per_month;
          // this.netTaxAmount = res.data.result.tax_per_month;
          this.salaryCalculations.forEach((element) => {
            if (element.user.id === idd) {
              this.empAllow[element.user.id]  = allowances;
              this.empDect[element.user.id]   = deduct || 0;
              element.allownces               = allowances;
              element.EmployeeBenefits        = benifits;

              if(element.user.tax_amount>0){
                this.empTax[idd]   =element.user.tax_amount;
              }else{
                this.empTax[idd]   = res.data.result.tax_per_month;
              }
              // this.empTax[element.user.id]    = res.data.result.tax_per_month;
              this.sumOfBonusDeduction[idd] = element.basic_salary + element.allownces - this.empDect[idd];

              var sumSalaryAndBonus=element.basic_salary + parseInt(element.allownces);
              var sumSalaryAndDedec=this.empDect[idd] + this.empTax[idd];
             // console.log(sumSalaryAndBonus,sumSalaryAndDedec)
              this.empNetPay[idd] = sumSalaryAndBonus - sumSalaryAndDedec;

            }
           // console.log(this.empNetPay[element.user.id],'this.empNetPay[element.user.id]');
            this.sumAllAmount += (this.empNetPay[element.user.id] != undefined)?this.empNetPay[element.user.id]:0;

          });

          $("#deduction-modal").modal("hide");
        }
      });
    },
    addTableRow() {
      this.tableRows.push(this.tableRowsCount++);

    },
    delTableRow(id) {
      this.employeeAllowncesArray = this.employeeAllowncesArray.filter(
        (item) => item.id !== id
      );

    },
    delTableRow2(id,rowRef) {
      $('#'+rowRef).remove();
    },
    clearData(){
      this.tableRowsCount = 2;
    },
    addRow(index, employeId) {
      //add row in table

      if (this.rows[employeId] != null) {
        this.arrayofAllownces = [...this.rows[employeId]];
        this.dataArray[employeId] = this.arrayofAllownces;
      }
      this.rows[employeId].push({
        type: "",
        description: "",
        amount: "",
      });
      // this.lock.employee_id[employeId];
      const isInArray = this.lock.employee_id.includes(employeId);
      if (isInArray === false) {
        this.lock.employee_id.push(employeId);
      }

      this.AllowncesCal(employeId);
    },
    delRow(index, employeId) {
      //del row in table

      this.indexEmp = index;
      this.empID = employeId;

      this.rows[employeId].splice(index, 1);

      this.AllowncesCal(employeId);
      if (this.arrayofAllownces.length <= 2) {
        this.employees.forEach((element) => {
          if (element.id == employeId) {
            this.user[employeId].bonus = element.sumofAllownce;
            this.user[employeId].deduction = 0;
            this.user[employeId].tax = element.withoutTaxSalary;
            this.user[employeId].netAmount = element.net_payable;

            this.empAllow[employeId] = element.sumofAllownce; // for display only totalAllownce -
            this.empDect[employeId] = 0; // for display only totalDedyction
            this.empTax[employeId] = element.withoutTaxSalary; // for display only totalTax
            this.empNetPay[employeId] = element.net_payable; // for display only TotalNetPay
          }
          // "withoutTaxSalary":6400,"net_payable":57600,
          //  deduction: this.deduction, tax: this.tax, netAmount: this.netAmount,bonus: this.bonuses
        });
      }
    },
    onChange() {
      //date change format when select date
      this.is_calculate     = 0;
      this.invalidCalc      = '';
      this.form.from_date   = moment(this.range[0]).format("YYYY-MM-DD");
      this.form.to_date     = moment(this.range[1]).format("YYYY-MM-DD");

      this.lock.from_date   = moment(this.range[0]).format("YYYY-MM-DD");
      this.lock.to_date     = moment(this.range[1]).format("YYYY-MM-DD");
      // this.GetSalaryCalculation();
    },
    GetSalaryCalculation() {
      this.loadingSpinMain= true;

      this.totalBasicSalary = 0;
      this.totalAllowance   = 0;
      this.totalDeduction   = 0;
      this.totalTax         = 0;

      let params = {
        company_id: this.company_id,
        salary_calculation_period_id: this.salaryCalculationPeriodId,
      };
      this.$axios
        .get(this.$GetSalaryCalculationEdit, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.loadingSpinMain= false;
          this.salaryFrom=this.form.from_date=moment(response.data.result.from_date).format("YYYY-MM-DD");
          this.salaryTo=this.form.to_date=moment(response.data.result.to_date).format("YYYY-MM-DD");
          this.calculationType=(response.data.result.calculation_type==true?'without':'with');
          this.salaryType=(response.data.result.calculation_type==true?'Salary is calculated without attendance':'Salary is calculated with attendance');
          this.salaryCalculations= response.data.result.salaryCalculations;

          this.employees              = response.data.result.salaryCalculations;
          this.employeeAllowncesArray = response.data.result.employeeAllownces;
          let alwnceArrIds            = this.employeeAllowncesArray.map(id => id.employee_id);
         // console.log(this.employeeAllowncesArray,'this.employeeAllowncesArray');
          this.salaryCalculations.forEach((element) => {

            if(alwnceArrIds.indexOf(element.employee_id) !== -1){
              let compalw = collect(this.employeeAllowncesArray).where('employee_id',element.employee_id).all().map((alw) => {
                return {
                  company_id      : alw.company_id,
                  employee_id     : alw.employee_id,
                  type            : alw.type,
                  benefits_amount : alw.amount,
                  companyBenefit  : {
                    name    : alw.description,
                    amount  : alw.amount,
                    benefits_amount  : alw.amount,
                  }
                }
              });
              element.user.EmployeeBenefits = compalw;
            }
            if(element.user.basic_salary !=0){
              this.empCurrentSalary[element.user.id]   =  element.basic_salary;
              this.totalBasicSalary += element.basic_salary;
            }
            if (element.allownces !=0){
              this.empAllow[element.user.id]   = element.allownces;
              // this.totalAllowance   += element.allownces;
              this.totalAllowance   += this.empAllow[element.user.id];
            }
            if(element.deductions !=0){
              this.empDect[element.user.id]    = element.deductions;
              this.totalDeduction   += this.empDect[element.user.id];
            }

           if(element.tax !=0  ){
            // console.log(element.tax,'element.tax');
             this.empTax[element.user.id]     = element.tax;
             this.totalTax         += this.empTax[element.user.id];
           }
           var netAmount=element.basic_salary + element.allownces - element.deductions - element.tax;
           if(netAmount !=0){
             this.empNetPay[element.user.id]=netAmount;
             this.sumAllAmount     += this.empNetPay[element.user.id];
           }

          });
          this.lockShowHide = true;
        //  console.log(this.empAllow,'this.empAllow');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    totalSalaries() {
      this.employees.forEach((element) => {
        this.taxAmount.push((element.allownce_withBasicSalary / 100) * 10);
        this.sumAllAmount += element.net_payable;
        // this.sumAllAmount += this.empNetPay[element.id]
      });
    },

    onChangeAllownces(event, val, comp) {
      //when value changed on pre defined allownces

    },
    taxCalulate(value) {
      // tax value
      return (value / 100) * 10;
    },
    AllowncesCal(id) {
      //all calculation addition subtraction

      if (this.rows[id] != null) {
        this.arrayofAllownces = [...this.rows[id]];
        this.dataArray[id] = this.arrayofAllownces;
      }
      const isInArray = this.lock.employee_id.includes(id);
      if (isInArray === false) {
        this.lock.employee_id.push(id);
      }

      this.deduction = 0;
      this.bonus = 0;
      this.employees.forEach((el) => {
        this.arrayofAllownces.forEach((element) => {
          if (el.id == this.popid && element.type == "Bonus") {
            this.bonus = this.bonus + +element.amount;
            if (this.deduction != 0) {
              var sumupValue = el.sumofAllownce + this.bonus;
              this.bonuses = sumupValue;
              var afterDeduction = sumupValue - this.deduction;

              var sumupValue1 = +el.basicSalary + +afterDeduction;

              this.tax = this.taxCalulate(sumupValue1);
              this.netAmount = sumupValue1 - this.tax;

              this.salaries[el.id] = this.netAmount;
              var newValues = {
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: this.bonuses,
              };
              this.user[el.id] = newValues;

              // var newValues1 = { basic_salary: el.basicSalary ,deduction: this.deduction, tax: this.tax, netAmount: this.netAmount,bonus: this.bonuses };
              // var objectToArray = Object.entries(newValues1);
              // this.bonusArray[el.id] = objectToArray;         //final array for salaryCalculation table
              this.bonusArray[el.id] = [];
              this.is_calculate = 1;
              this.bonusArray[el.id].push({
                basic_salary: el.basicSalary,
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: this.bonuses,
              });
            } else {
              sumupValue = el.sumofAllownce + this.bonus;
              this.bonuses = sumupValue;
              sumupValue1 = +el.basicSalary + +sumupValue;
              this.tax = this.taxCalulate(sumupValue1);
              this.netAmount = sumupValue1 - this.tax;

              this.salaries[el.id] = this.netAmount;

              var newValues = {
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: this.bonuses,
              };
              this.user[el.id] = newValues;

              this.is_calculate = 1;
              this.bonusArray[el.id] = [];
              this.bonusArray[el.id].push({
                basic_salary: el.basicSalary,
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: this.bonuses,
              });
            }

            this.empAllow[el.id] = this.bonuses; // for display only totalAllownce
            this.empDect[el.id] = this.deduction; // for display only totalDedyction
            this.empTax[el.id] = this.tax; // for display only totalTax
            this.empNetPay[el.id] = this.netAmount; // for display only TotalNetPay
          } else if (el.id == this.popid && element.type == "Deduction") {
            this.deduction = this.deduction + +element.amount;
            if (this.bonus != 0) {
              var sumupValue = el.sumofAllownce + this.bonus;
              this.bonuses = sumupValue;
              var afterDeduction = sumupValue - this.deduction;
              var sumupValue1 = +el.basicSalary + +afterDeduction;

              this.tax = this.taxCalulate(sumupValue1);
              this.netAmount = sumupValue1 - this.tax;

              this.salaries[el.id] = this.netAmount;
              var newValues = {
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: sumupValue,
              };
              this.user[el.id] = newValues;
              this.bonusArray[el.id] = [];
              this.is_calculate = 1;
              this.bonusArray[el.id].push({
                basic_salary: el.basicSalary,
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: sumupValue,
              });

              this.empAllow[el.id] = sumupValue; // for display only totalAllownce
              this.empDect[el.id] = this.deduction; // for display only totalDedyction
              this.empTax[el.id] = this.tax; // for display only totalTax
              this.empNetPay[el.id] = this.netAmount; // for display only TotalNetPay
            } else {
              // console.log('Dect else');
              sumupValue = el.allownce_withBasicSalary - this.deduction;
              this.tax = this.taxCalulate(sumupValue);
              this.netAmount = sumupValue - this.tax;

              this.salaries[el.id] = this.netAmount;

              var newValues = {
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: this.bonus,
              };
              this.user[el.id] = newValues;
              this.bonusArray[el.id] = [];
              this.is_calculate = 1;
              this.bonusArray[el.id].push({
                basic_salary: el.basicSalary,
                deduction: this.deduction,
                tax: this.tax,
                netAmount: this.netAmount,
                bonus: el.sumofAllownce,
              });
              this.empAllow[el.id] = el.sumofAllownce; // for display only totalAllownce
              this.empDect[el.id] = this.deduction; // for display only totalDedyction
              this.empTax[el.id] = this.tax; // for display only totalTax
              this.empNetPay[el.id] = this.netAmount; // for display only TotalNetPay
            }
          }
        });
      });

      this.sumAllAmount = 0.0;
      this.salaries.forEach((element) => {
        this.sumAllAmount = +this.sumAllAmount + +element;
      });
    },

    UpdateCalculation() {
      if(this.lockOrUpdateCheck){
        var message   = 'Are you sure that you want to update this calculation?';
        var message2  = 'Salary updated successfully!';
      }else{
            message   = 'Are you sure that you want to lock this salary?';
            message2  = 'Salary saved successfully!';
      }

      // return;
      if(confirm(message)){
            this.updateLoading = true;
            var employeeAllowances  = this.empAllow;
            var employeeDeductions  = this.empDect;
            var employeeTaxs        = this.empTax;
            var data = {
              allowances      : employeeAllowances,
              deductions      : employeeDeductions,
              taxs            : employeeTaxs,
              employees       : this.employees,
              from_date       : this.form.from_date,
              end_date        : this.form.to_date,
              company_id      : this.company_id,
              selectedCompany : this.$store.getters.getSelectedCompany,
              seperateAllw    : this.seperateAllowances,
              originalAllw    : this.employeeBenefitArray,
              netAmount       : this.empNetPay,
              allMoreBenefitsDeductions: this.allMoreBenefitsDeductions,
              salaryCalculationPeriodId: this.salaryCalculationPeriodId,
              attendanceConfirm: this.calculationType,
              lockOrUpdateCheck: this.lockOrUpdateCheck
            };
            //console.log(data,'data ');
            this.$axios({
              method  : "POST",
              data    : data,
              url     : this.$UpdateCalculateSalary,
              headers : this.getAuthHeader(),
            }).then((res) => {
              this.updateLoading      = false;
              this.lockOrUpdateCheck  = true;
              if (res.data.status == 200) {
                this.tableRows                  = [];
                this.allMoreBenefitsDeductions  = [];
                this.bonusAndDeductionArray     = [];
                this.singleEmployee             = [];
                this.bonusDeductionLoop         = [];
                this.is_calculate++;
                $root.$toast.success(message2);
                this.$router.push({name: 'employee-salariesList'});
                this.loading = false;
              }
            });
          this.is_calculate++;
      }
    },

    lockSalarySendNotfi() {
      this.lockOrUpdateCheck = false;
      this.UpdateCalculation();
      return;
      if(confirm('Are you sure that you want to lock this salary?')){
        if(this.sumAllAmount !== 0){
        if (this.is_calculate === 0) {
          this.loading = true;
          var employeeAllowances  = this.empAllow;
          var employeeDeductions  = this.empDect;
          var employeeTaxs        = this.empTax;
          var data = {
            allowances      : employeeAllowances,
            deductions      : employeeDeductions,
            taxs            : employeeTaxs,
            employees       : this.employees,
            from_date       : this.form.from_date,
            end_date        : this.form.to_date,
            company_id      : this.company_id,
            selectedCompany : this.$store.getters.getSelectedCompany,
            seperateAllw    : this.seperateAllowances,
            originalAllw    : this.employeeBenefitArray,
            netAmount       :this.empNetPay,
            allMoreBenefitsDeductions: this.allMoreBenefitsDeductions,
            salaryCalculationPeriodId: this.salaryCalculationPeriodId,
            attendanceConfirm: this.calculationType
          };

          this.$axios({
            method  : "POST",
            data    : data,
            url     : this.$lockSalarySendNotificationEmp,
            headers : this.getAuthHeader(),
          }).then((res) => {
            if (res.data.status == 200) {
              this.tableRows                  = [];
              this.allMoreBenefitsDeductions  = [];
              this.bonusAndDeductionArray     = [];
              this.singleEmployee             = [];
              this.bonusDeductionLoop         = [];
              this.is_calculate++;
              $root.$toast.success('Salary saved successfully!');
              this.$router.push({name: 'employee-salariesList'});
              this.loading = false;
            }
          });
        } else {
          $root.$toast.success("This salary lock saved already!");
        }
        this.is_calculate++;
      }else{
        $root.$toast.error("Please add basic salary before to lock");
      }
      }
    },

    email() {
      if (this.is_calculate == 1) {
        this.$axios
          .post(this.$LockEmail, this.lock, {
            headers: this.getAuthHeader(),
          })
          .then((response) => {

            this.lock1 = response.data.result;
            alert("lock value has updated and sent an email");
          })
          .catch((error) => {
            // console.log(error);
            this.is_data_ready = true;
          });
      } else {
        alert("first add calculations");
      }
    },
    currencyFormatter2(value){
     return this.currencyFormatter(value);
    },
  },
};
</script>
<style>

.hour-salary tbody tr td.p-0 {
  padding: 0 !important;
}
.total-td{
  text-align: right !important;
}
.ml-n15 {
  margin-left: -15px !important;
}
.li-width {
  width: 225px !important;
}
.textRed{
  color: red;
}
.custom-radio span{
  font-size: 18px !important;
  line-height: 22px !important;
}
.spinnerCustom .v-spinner {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  z-index: 1111111;
  top: 50%;
}
</style>
